import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  default as VARIABLES
} from './../../../themes/styles/bases/variables'
import {
  CmsLayoutBaseWrapper,
  CmsLayoutContentBaseWrapper,
  CmsLayoutSidebarBaseWrapper,
  CmsLayoutTopbarBaseWrapper
} from './styled'

class CmsLayoutTopbarBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
      topbarHeight,
      topbarPadding,
      topbarPaddingTop,
      topbarPaddingRight,
      topbarPaddingBottom,
      topbarPaddingLeft,
      topbarPaddingHorizontal,
      topbarPaddingVertical,
      topbarBgColor,
      topbarBorderBottomWidth,
      topbarBorderBottomStyle,
      topbarBorderBottomColor,
      topbarBoxShadow
    } = this.props

    return (
      <CmsLayoutTopbarBaseWrapper
        className={ClassNames(
          'cms-layout-topbar-base',
          // Option
          className
        )}
        theme={{
          // Default
          topbarHeight,
          topbarPadding,
          topbarPaddingTop,
          topbarPaddingRight,
          topbarPaddingBottom,
          topbarPaddingLeft,
          topbarPaddingHorizontal,
          topbarPaddingVertical,
          topbarBgColor,
          topbarBorderBottomWidth,
          topbarBorderBottomStyle,
          topbarBorderBottomColor,
          topbarBoxShadow
        }}
      >
        {children}
      </CmsLayoutTopbarBaseWrapper>
    )
  }

  static defaultProps = {
    topbarHeight: VARIABLES.CMS_LAYOUT.TOPBAR.HEIGHT
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func

    className: PropTypes.string,
    topbarHeight: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    topbarPadding: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    topbarPaddingTop: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    topbarPaddingRight: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    topbarPaddingBottom: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    topbarPaddingLeft: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    topbarPaddingHorizontal: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    topbarPaddingVertical: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    topbarBgColor: PropTypes.string,
    topbarBorderBottomWidth: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    topbarBorderBottomStyle: PropTypes.string,
    topbarBorderBottomColor: PropTypes.string,
    topbarBoxShadow: PropTypes.string,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}

class CmsLayoutSidebarBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
      sidebarWidth,
      sidebarPadding,
      sidebarPaddingTop,
      sidebarPaddingRight,
      sidebarPaddingBottom,
      sidebarPaddingLeft,
      sidebarPaddingHorizontal,
      sidebarPaddingVertical,
      sidebarBgColor,
      sidebarBoxShadow
    } = this.props

    return (
      <CmsLayoutSidebarBaseWrapper
        className={ClassNames(
          'cms-layout-sidebar-base',
          // Option
          className
        )}
        theme={{
          // Default
          sidebarWidth,
          sidebarPadding,
          sidebarPaddingTop,
          sidebarPaddingRight,
          sidebarPaddingBottom,
          sidebarPaddingLeft,
          sidebarPaddingHorizontal,
          sidebarPaddingVertical,
          sidebarBgColor,
          sidebarBoxShadow
        }}
      >
        {children}
      </CmsLayoutSidebarBaseWrapper>
    )
  }

  static defaultProps = {
    sidebarWidth: VARIABLES.CMS_LAYOUT.SIDEBAR.WIDTH
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string,
    sidebarWidth: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    sidebarPadding: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    sidebarPaddingTop: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    sidebarPaddingRight: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    sidebarPaddingBottom: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    sidebarPaddingLeft: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    sidebarPaddingHorizontal: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    sidebarPaddingVertical: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    sidebarBgColor: PropTypes.string,
    sidebarBoxShadow: PropTypes.string,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}

class CmsLayoutContentBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
      contentPadding,
      contentPaddingTop,
      contentPaddingRight,
      contentPaddingBottom,
      contentPaddingLeft,
      contentPaddingHorizontal,
      contentPaddingVertical,
      contentBgColor
    } = this.props

    return (
      <CmsLayoutContentBaseWrapper
        className={ClassNames(
          'cms-layout-content-base',
          // Option
          className
        )}
        theme={{
          // Default
          contentPadding,
          contentPaddingTop,
          contentPaddingRight,
          contentPaddingBottom,
          contentPaddingLeft,
          contentPaddingHorizontal,
          contentPaddingVertical,
          contentBgColor
        }}
      >
        {children}
      </CmsLayoutContentBaseWrapper>
    )
  }

  static defaultProps = {
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func

    className: PropTypes.string,
    contentPadding: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    contentPaddingTop: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    contentPaddingRight: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    contentPaddingBottom: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    contentPaddingLeft: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    contentPaddingHorizontal: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    contentPaddingVertical: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    contentBgColor: PropTypes.string,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}

export class CmsLayoutBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
      bgColor
    } = this.props

    return (
      <CmsLayoutBaseWrapper
        className={ClassNames(
          'cms-layout-base',
          // Option
          className
        )}
        theme={{
          // Default
          bgColor
        }}
      >
        {children}
      </CmsLayoutBaseWrapper>
    )
  }

  static Topbar = CmsLayoutTopbarBase
  static Sidebar = CmsLayoutSidebarBase
  static Content = CmsLayoutContentBase

  static defaultProps = {
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func

    className: PropTypes.string,
    bgColor: PropTypes.string,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}
